import { render, staticRenderFns } from "./custom-video-type-1.vue?vue&type=template&id=687f2f44&scoped=true&"
import script from "./custom-video-type-1.vue?vue&type=script&lang=js&"
export * from "./custom-video-type-1.vue?vue&type=script&lang=js&"
import style0 from "./custom-video-type-1.vue?vue&type=style&index=0&id=687f2f44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687f2f44",
  null
  
)

export default component.exports